export const getIntercomAppId = () => process.env.VITE_INTERCOM_APP_ID;
